import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import { FALLBACK_PLANS } from '../constants/plans'
import type { PlansResponse } from '../types'

export function useQuerySubscriptionPlans() {
  return useQuery<PlansResponse>({
    queryKey: ['subscription.plans'],
    queryFn: async () => {
      try {
        const { data } = await axiosInstance.get<PlansResponse>('/config-api/subscription/plans')
        return data
      } catch {
        return FALLBACK_PLANS
      }
    },
    staleTime: 60 * 60 * 1000,
  })
}
